import { styled } from '@clickcease/cc-client-components-lib'

export const PDFHeaderWrapper = styled('div', {})

export const PDFHeaderTitleSection = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  backgroundColor: '$white',
  borderRadius: '14px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
  padding: '20px',
  height: '100px',
})

export const PDFHeaderTitle = styled('div', {
  fontSize: '36px',
  fontWeight: '100',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
})

export const PDFHeaderDateSection = styled('div', {
  fontSize: '24px',
})

export const PDFDomainsSection = styled('div', {
  marginTop: '20px',
  fontSize: '24px',
  backgroundColor: '$white',
  borderRadius: '14px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
  padding: '20px',
  height: '30px',
  textAlign: 'center',
})

export const LogoWrapper = styled('div', {})
